import { navigate } from '@redwoodjs/router'

const setDateRangeParams = (
  searchParams: URLSearchParams,
  key: string,
  gte: Date | null | undefined,
  lte: Date | null | undefined
) => {
  if (gte) {
    searchParams.set(`${key}Gte`, gte.toISOString())
  } else {
    searchParams.delete(`${key}Gte`)
  }
  if (lte) {
    searchParams.set(`${key}Lte`, lte.toISOString())
  } else {
    searchParams.delete(`${key}Lte`)
  }
}

export function updateFiltersInUrl(filters) {
  const searchParams = new URLSearchParams(location.search)

  if (filters?.searchText) {
    searchParams.set('searchText', filters.searchText)
  } else {
    searchParams.delete('searchText')
  }

  for (const filterKey in filters) {
    const filter = filters[filterKey]

    if (filterKey === 'tab') {
      if (filter) {
        searchParams.set('tab', filter)
      } else {
        searchParams.delete('tab')
      }
    }

    if (filterKey === 'statuses') {
      if (filter?.length > 0) {
        searchParams.set(filterKey, filter)
      } else {
        searchParams.delete(filterKey)
      }
    }

    if (filterKey === 'createdAt') {
      setDateRangeParams(searchParams, 'createdAt', filter.gte, filter.lte)
    }

    if (filterKey === 'assigneeIds') {
      if (filter?.length > 0) {
        searchParams.set('assigneeIds', filter.join(','))
      } else {
        searchParams.delete('assigneeIds')
      }
    }

    if (filterKey === 'minContactAttempts') {
      if (filter !== null && filter !== undefined) {
        searchParams.set('minContactAttempts', String(filter))
      } else {
        searchParams.delete('minContactAttempts')
      }
    }

    if (filterKey === 'maxContactAttempts') {
      if (filter !== null && filter !== undefined) {
        searchParams.set('maxContactAttempts', String(filter))
      } else {
        searchParams.delete('maxContactAttempts')
      }
    }

    if (filterKey === 'lastContactDate') {
      setDateRangeParams(
        searchParams,
        'lastContactDate',
        filter.gte,
        filter.lte
      )
    }

    if (filterKey === 'employmentStartDate') {
      setDateRangeParams(
        searchParams,
        'employmentStartDate',
        filter.gte,
        filter.lte
      )
    }

    if (filterKey === 'employmentEndDate') {
      setDateRangeParams(
        searchParams,
        'employmentEndDate',
        filter.gte,
        filter.lte
      )
    }

    if (filterKey === 'applicantStages') {
      if (filter?.length > 0) {
        searchParams.set('applicantStages', filter.join(','))
      } else {
        searchParams.delete('applicantStages')
      }
    }

    if (filterKey === 'neverContacted') {
      if (filter) {
        searchParams.set('neverContacted', 'true')
      } else {
        searchParams.delete('neverContacted')
      }
    }

    if (filterKey === 'contactInfoFilter') {
      if (filter?.length > 0) {
        searchParams.set('contactInfoFilter', filter.join(','))
      } else {
        searchParams.delete('contactInfoFilter')
      }
    }

    if (filterKey === 'consentFilter') {
      if (filter?.length > 0) {
        searchParams.set('consentFilter', filter.join(','))
      } else {
        searchParams.delete('consentFilter')
      }
    }

    if (filterKey === 'responseFilter') {
      if (filter?.length > 0) {
        searchParams.set('responseFilter', filter.join(','))
      } else {
        searchParams.delete('responseFilter')
      }
    }

    if (filterKey === 'nextActionFilter') {
      if (filter?.length > 0) {
        searchParams.set('nextActionFilter', filter.join(','))
      } else {
        searchParams.delete('nextActionFilter')
      }
    }

    if (filterKey === 'sortField') {
      if (filter) {
        searchParams.set('sortField', filter)
      } else {
        searchParams.delete('sortField')
      }
    }

    if (filterKey === 'sortDirection') {
      if (filter) {
        searchParams.set('sortDirection', filter)
      } else {
        searchParams.delete('sortDirection')
      }
    }

    if (filterKey === 'hiringStageTab') {
      if (filter) {
        searchParams.set('hiringStageTab', filter)
      } else {
        searchParams.delete('hiringStageTab')
      }
    }
  }
  navigate(`?${searchParams.toString()}`, { replace: true })
}
